export default __webpack_public_path__ + "static/media/slide-image-next.eb893186.svg";